
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/buyguthealthtest",
      function () {
        return require("private-next-pages/[locale]/buyguthealthtest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/buyguthealthtest"])
      });
    }
  